<template>
  <div>
    <search-form
      :fetchData="fetch"
      ref="searchFormRef"
      :handelSearch="handelSearch"
      :handelAdd="showAddModal"
      :collection="formCollection"
      :ableSearch="ableSearch"
      :resetWillRequest="true"
      @reset="handelSearch"
      :ableAdd="ableAdd"
    ></search-form>
    <div class="flexend">
      <a-button
        @click="
          fileExport({
            name: `车辆黑白名单批量导入Excel模板.xlsx`,
            url: `/api/carBlackWhiteList/excelTemplate`,
          })
        "
      >
        导入模板下载
      </a-button>
      <FileUpload
        :showList="false"
        url="/carBlackWhiteList/excelImport"
        fileField="file"
        @uploadSuccess="importSuccess"
        v-if="true"
      >
        <a-button type="primary">批量导入</a-button>
      </FileUpload>
    </div>
    <a-modal
      v-model:open="open"
      :title="(isEdit ? '编辑' : '新增') + pageName"
      :footer="null"
      :destroyOnClose="true"
      :keyboard="false"
      class="action-form-model-small"
    >
      <action
        :v-if="open"
        @submit="clickOk"
        :isEdit="isEdit"
        :editData="editData"
        :isDetail="isDetail"
        :data="tableData"
        :idField="idField"
      ></action>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :scroll="{x: 'max-content'}"
      size="small"
    >
      <template #bodyCell="{ column, record, index }">
        <template v-if="column.key === 'rowIndex'">
          {{ index + 1 }}
        </template>
        <template v-if="column.key === 'action'">
          <span>
            <a-button
              @click="showEditModal(record, true)"
              :loading="loadingRecord === record"
            >
              详情
            </a-button>
            <a-button
              @click="showEditModal(record, false)"
              :loading="loadingRecord === record"
              v-if="
                ableEdit &&
                (record.status === 0 ||
                record.status === 3 ||
                record.status === 4)
              "
            >
              编辑
            </a-button>
            <a-button
              @click="showApprovalProcess(record)"
              :loading="loadingRecord === record"
              v-if="record.status !== 0"
            >
              审批流程
            </a-button>
            <a-popconfirm
              title="确认提交？"
              ok-text="确认"
              cancel-text="取消"
              @confirm="pushRow(record)"
              v-if="ableCommit && record.status === 0"
            >
              <a-button>提交</a-button>
            </a-popconfirm>
            <a-button
              @click="showRevokeModal(record)"
              v-if="ableRevoke && (record.status === 1 || record.status === 2)"
              :loading="loadingRecord === record[idField] + 'revoke'"
              danger
            >撤销审批</a-button>
            <a-popconfirm
              v-if="ableDelete && (record.status !== 1 && record.status !== 2)"
              title="确认删除？"
              ok-text="确认"
              cancel-text="取消"
              @confirm="delRow(record)"
            >
              <a-button danger>删除</a-button>
            </a-popconfirm>
          </span>
        </template>
        <table_data_format
          v-else
          :record="record"
          :column="column"
        ></table_data_format>
      </template>
    </a-table>
    <approval_process
      v-model:openModal="approvalProcessOpen"
      :data="approvalProcessData"
    ></approval_process>

    <a-modal v-model:open="revokeModalOpen" title="是否撤销审批？">
      <a-form :model="revokeModalData" ref="revokeModalFormRef" :rules="revokeModalRules">
        <a-form-item label="撤销理由" name="reason">
          <a-textarea v-model:value="revokeModalData.reason" placeholder="请输入撤销理由" />
        </a-form-item>
      </a-form>
      <template #footer>
        <a-button @click="revokeModalOpen = false">取消</a-button>
        <a-button type="primary" @click="revokeRow">确定</a-button>
      </template>
    </a-modal>
  </div>
</template>
<script setup>
  import { ref, onMounted, toRefs, computed } from 'vue'
  import { useStore } from 'vuex'
  import {
    getData,
    deleteData,
    getDetail,
    pushData,
    revoke,
    approvalProcess,
  } from '@/api/black_white_list/car_black_white_list'
  import action from './action'
  import { message } from 'ant-design-vue'
  import { codeToText } from '@/utils/format'
  import searchForm from '@/components/search_form'
  import approval_process from '@/components/approval_process'
  import table_data_format from '@/components/table_data_format'
  import { fileExport } from '@/utils/download'
  import FileUpload from '@/components/form/file_upload'

  //初始化
  const pageName = '车辆黑白名单'
  const idField = 'id' //响应数据的id的字段名
  const store = useStore()
  const Enum = toRefs(store.state.common)

  const permissionList = computed(() => store.getters['user/permissionList'])
  const ableSearch = computed(() =>
    //!!permissionList.value?.find(item => item.code === 'carList:list')
      true
  )
  const ableAdd = computed(() =>
    !!permissionList.value?.find(item => item.code === 'carList:add')
  )
  const ableEdit = computed(() =>
    !!permissionList.value?.find(item => item.code === 'carList:edit')
  )
  const ableDelete = computed(() =>
    !!permissionList.value?.find(item => item.code === 'carList:delete')
  )
  const ableRevoke = computed(() =>
    !!permissionList.value?.find(item => item.code === 'carList:revoke')
  )
  const ableCommit = computed(() =>
    !!permissionList.value?.find(item => item.code === 'carList:commit')
  )

  //1、搜索框
  const formCollection = [
    {
      type: 'input',
      field: 'license_plate',
      label: '车牌号码',
    },
    {
      type: 'select',
      field: 'type',
      storeOptions: 'blackWhiteListType',
      defaultValue: -1,
      // 'allow-clear': true,
      label: '名单类型',
      width: '130px',
    },
    {
      type: 'select',
      field: 'status',
      storeOptions: 'status',
      defaultValue: -1,
      // 'allow-clear': true,
      label: '状态',
      width: '130px',
    },
    {
      type: 'select',
      field: 'expired',
      storeOptions: 'delayedType',
      defaultValue: -1,
      label: '有效期类型',
      width: '130px',
    },
  ]
  const searchFormRef = ref()
  function handelSearch() {
    pagination.value.current = 1
    fetch()
    const params = {
      ...searchFormRef.value.formState
    }
    store.commit('search/setBlackCar', params)
  }

  //2、表格
  const columns = [
    {
      title: '序号',
      dataIndex: 'rowIndex',
      key: 'rowIndex',
      align: 'center',
      width: 50,
      fixed: 'left',
    },
    {
      title: '车牌号码',
      dataIndex: 'license_plate',
      key: 'license_plate',
      align: 'left',
    },
    {
      title: '车型',
      key: 'vehicle_type_id',
      align: 'left',
    },
    {
      title: '名单类型',
      key: 'blackWhiteListType',
      align: 'left',
    },
    {
      title: '时间范围',
      key: 'time_range',
      align: 'left',
    },
    {
      title: '审核状态',
      dataIndex: 'status',
      key: 'status',
      align: 'left',
    },
    {
      title: '原因备注',
      dataIndex: 'in_reason',
      key: 'in_reason',
      align: 'left',
    },
    {
      title: '撤销理由',
      dataIndex: 'revoke_reason',
      key: 'revoke_reason',
      align: 'left',
    },
    {
      title: '创建人',
      dataIndex: 'create_user_id',
      key: 'create_user_id',
      align: 'left',
    },
    {
      title: '修改人',
      dataIndex: 'update_user_id',
      key: 'update_user_id',
      align: 'left',
    },
    {
      title: '创建时间',
      dataIndex: 'create_time',
      key: 'create_time',
      align: 'left',
    },
    {
      title: '更新时间',
      dataIndex: 'update_time',
      key: 'update_time',
      align: 'left',
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'left',
      fixed: 'right',
      //width: '330px',
    },
  ]

  const tableData = ref([])
  const loading = ref(false)
  const loadingRecord = ref()
  const pagination = ref({
    current: 1,
    pageSize: 10,
    showLessItems: true,
    showQuickJumper: true,
    showSizeChanger: true,
    showTotal: (total, range) => {
      return `共 ${total} 条`
    },
  })

  function handleTableChange(page) {
    pagination.value = { ...pagination.value, ...page }
    fetch()
  }

  function importSuccess() {
    setTimeout(() => {
      fetch()
    }, 1000)
  }

  function fetch() {
    //获取表单值
    const formState = searchFormRef.value?.formState

    loading.value = true
    getData({
      size: pagination.value.pageSize,
      pn: pagination.value.current,
      ...formState,
    }).then(({ data }) => {
      loading.value = false
      tableData.value = data.list
      pagination.value.total = data.total
    })
  }
  
  const cachedSearchParams = computed(() => store.state.search.searchBlackCar)
  onMounted(() => {
    for (const key in cachedSearchParams.value) {
      searchFormRef.value.formState[key] = cachedSearchParams.value[key]
    }
    fetch()
  })

  //3、编辑、添加
  const open = ref(false)
  const isEdit = ref(false)
  const editData = ref(null)

  const showAddModal = () => {
    editData.value = null
    isEdit.value = false
    open.value = true
  }
  const isDetail = ref(false)
  const showEditModal = async (data, _isDetail) => {
    loadingRecord.value = data
    const detail = await fetchDetail(data[idField])
    loadingRecord.value = null
    if (detail) {
      editData.value = detail
      isEdit.value = true
      isDetail.value = _isDetail
      open.value = true
    }
  }

  async function fetchDetail(id) {
    const res = await getDetail({ id })
    if (res.success) {
      return res.data
    } else {
      message.warn('获取详情失败')
    }
  }

  function clickOk() {
    fetch()
    handleOk()
    clearEditData()
  }

  const handleOk = () => {
    open.value = false
  }
  const clearEditData = () => {
    editData.value = null
  }

  //4、删除
  async function delRow(data) {
    const res = await deleteData({ id: data[idField] })
    if (res.success) {
      message.success('删除成功！')
      fetch()
    } else {
      message.warn('删除失败' + res.message)
    }
  }
  //5、提交
  async function pushRow(data) {
    const res = await pushData({ id: data[idField] })
    if (res.success) {
      message.success('提交成功！')
      fetch()
    } else {
      message.warn('提交失败' + res.message)
    }
  }
  //6、撤销审核
  async function revokeRow() {
    await revokeModalFormRef.value.validate()
    const { id, reason } = revokeModalData.value
    loadingRecord.value = id + 'revoke'
    try {
      const res = await revoke({ id, reason })
      if (res.success) {
        message.success('撤销审核成功！')
        revokeModalOpen.value = false
        fetch()
      } else {
        message.warn('撤销审核失败' + res.message)
      }
    } finally {
      loadingRecord.value = null
    }
  }
  //7、审批流程
  const approvalProcessOpen = ref(false)
  const approvalProcessData = ref()
  async function getApprovalProcess(id) {
    const res = await approvalProcess({ id })
    approvalProcessData.value = res.data
  }
  async function showApprovalProcess(record) {
    await getApprovalProcess(record[idField])
    approvalProcessOpen.value = true
  }

  const revokeModalFormRef = ref()
  const revokeModalRules = {
    reason: [
      { required: true, message: '请输入撤销理由', trigger: 'blur' }
    ]
  }
  const revokeModalOpen = ref(false)
  const revokeModalData = ref({
    reason: '',
    id: ''
  })
  function showRevokeModal(record) {
    revokeModalData.value = {
      reason: '',
      id: record[idField]
    }
    revokeModalOpen.value = true
  }
</script>

<style scoped>
.flexend {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-bottom: 10px;
}
</style>
